module.exports = __webpack_public_path__ + "static/media/marker_disruption.2bbd4b23.svg";